// Import store
import Store from 'store/store';

// Import actions
import { signOut, setPortalAvailability, setInternalServerError } from 'store/actions';

const checkServerStatus = (error) => {
	const url = error?.response?.config?.url;

	if (!url?.includes('recordings')) {
		Store.dispatch(setInternalServerError(true));
	}
};

export const checkErrorStatus = (error) => {
	const { response } = error;
	const status = response?.status;
	if (status === 401) {
		const authenticate = false;
		// Dispatch an signOut action in auth folder
		Store.dispatch(signOut(authenticate));

		return Promise.reject(error);
	} else if (status === 502) {
		Store.dispatch(setPortalAvailability());
		return Promise.reject(error);
	} else if (status === 500) {
		checkServerStatus(error);
		return Promise.reject(error);
	} else {
		return Promise.reject(error);
	}
};
